import React, { useContext, useEffect } from 'react';
import useOnChange from '../../../../hooks/useChange'
import { ContextBuilder } from '../../../../context/builder/reducers';
import Input from '../Input';
import TextArea from '../TextArea';
import UploadButton from '../UploadButton';

const AboutUs = (props) => {
    const { state, dispatch } = useContext(ContextBuilder);
    const onChange = useOnChange(props.index);
    useEffect(() => {
        if (!props.content) {
            const data = state.data;
            data.value[props.index].content = {title: '', subTitle: '', description: '', img: null };
            dispatch({ type: 'data', payload: { data: data } });
        }
    });

    return (
        <div className="about-us">
            <h2>About us</h2>
            <div className="form-group">
                <label>Title</label>
                <Input name="title" value={props.content.title || ''} onChange={onChange}/>
            </div>
            <div className="form-group">
                <label>SubTitle</label>
                <Input name="subTitle" value={props.content.subTitle || ''} onChange={onChange}/>
            </div>
            <div className="form-group">
                <label>Description</label>
                <TextArea name="description" value={props.content.description || ''} onChange={onChange} />
            </div>
            <div className="form-group">
                <label>Изображение</label>
                <div className="images">
                    <div className="img-container">
                        <div className="img-wrap">
                            <img src={props.content.img} alt=""/>
                        </div>
                    </div>
                </div>
                <div className="images">
                    <div className="image-container">
                        <div className="uploader">
                            <UploadButton name="img" onChange={onChange}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
